import React, { Fragment } from "react";
import { Box, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { MdOutlineSettingsPhone } from "react-icons/md";
import { MdOutlineMail } from "react-icons/md";
import { LinkedInLink } from "./layout/header";
import { FaLinkedin } from "react-icons/fa";
import { MdOutlineWhatsapp } from "react-icons/md";

export function CompanyAddress() {
  const { t } = useTranslation();
  return (
    <Fragment>
      <strong>
        MANGAL LEGAL <br />
        Rechtsanwaltsgesellschaft mbH
      </strong>{" "}
      <br /> <br />
      Hohe Bleichen 24-26
      <br />
      20354 Hamburg, {t("Germany")}
      <br />
      <br />
      <CompanyContactDetails />
    </Fragment>
  );
}

export function CompanyContactDetails() {
  const { t } = useTranslation();
  return (
    <VStack align="start" spacing={2}>
      <HStack spacing={4}>
        <Icon as={MdOutlineMail} />
        <a href="mailto:info@mangal.legal" style={{ textDecoration: "none" }}>
          info@mangal.legal
        </a>
      </HStack>
      <HStack spacing={4}>
        <Icon as={MdOutlineSettingsPhone} />
        <a href="tel:+494035700970" style={{ textDecoration: "none" }}>
          +49 40 357 00 97 0
        </a>
      </HStack>
      <HStack spacing={4}>
        <Icon as={FaLinkedin} />
        <a href={LinkedInLink} style={{ textDecoration: "none" }}>
          LinkedIn
        </a>
      </HStack>
    </VStack>
  );
}
